import { useCurrentUserQuery } from 'src/context/api/auth';
import { useCurrentWorkspace } from 'src/context/reducers/app-settings';

export const INTERNAL_ROLES = ['admin', 'brand specialist', 'consultant'];

/**
 * Whether the Visibility > Local tab is available for the current user.
 *
 * Single predicate on purpose: the tab, its route and the sidebar highlight all
 * read it, and the three drifting apart is how a customer ends up reaching a page
 * by URL that the navigation hides from them.
 *
 * Internal roles see the tab as soon as the module is on — `local_visibility`
 * only gates the customer role, which is the same rule Non Brand follows.
 */
export const useLocalFeatureEnabled = (): boolean => {
    const workspace: any = useCurrentWorkspace();
    const user: any = useCurrentUserQuery();
    const role = user?.data?.role;

    if (!workspace?.local) {
        return false;
    }
    return INTERNAL_ROLES.includes(role) || !!workspace?.local_visibility?.includes(role);
};
